<!-- 消息中心 -->
<template>
  <div class="c-message-box">

    <div class="all-message">
      <div class="c-read-box">
        <p>共<span class="blue-txt">{{messagelist.length}}</span>个消息</p>
        <!-- <p><img src="../../assets/main/yuedu@2x.png">全部阅读</p>
          <span class="batch-reading">批量阅读</span> -->
      </div>
      <ul class="message-list">
        <li v-for="m in curpageMsgList" :key="m.ckid">
          <!-- <div class="weidu"></div> -->
          <!-- <div class="yidu"></div> -->
          <div class="message-right-txt">
            <P class="p1">{{`${msgType[m.item]}-审核通知`}}</p>
            <P class="p2">{{m.comment}}</p>
            <P class="p3">时间：{{m.createTime}}</p>
          </div>
          <!-- <div class="right-delete-btn">
              <a href="javascript:;">删除</a>
              <a href="javascript:;">标记已读</a>
            </div> -->
        </li>
      </ul>

      <div class="paging-box">
        <el-pagination background layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange"
          :total=messagelist.length>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Pagination
  } from 'element-ui';
  import {
    getMessagesByUid,
  } from '@/api/messages';
  export default {
    name: 'MessageCenter',
    props: {
      msg: String,
    },
    components: {
      [Pagination.name]: Pagination,
    },
    data() {
      return {
        messagelist: [],
        curpageMsgList:[],
        msgType:{
          specialist:"专家管理",
          organization:"机构管理",
          project:"项目需求",
          product:"产品管理",
          service:"服务管理",
          video:"视频管理",
          case:"成功案例管理",
          standard:"标准管理",
          projectsingup:"资源匹配"
        }
      }
    },
    mounted() {
      this.queryMesseges()
    },
    methods: {
      queryMesseges() {
        this.$http.get(getMessagesByUid()).then(res => {
          if (res.code === 1) {
            this.messagelist = res.data
            this.messagelist = this.messagelist.reverse()
            this.handleCurrentChange(1)
          }
        })
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.curpageMsgList.splice(0,this.curpageMsgList.length)
        let curindex = (val-1)*10
        for(var i=curindex;i<curindex+10;i++){
          if(i<this.messagelist.length){
            this.curpageMsgList.push(this.messagelist[i])
          }
        }
      }
    }
  };
</script>

<style>
  @import url(./message.css);
</style>
